module.exports = __webpack_public_path__ + "img/highlighting-white.25d0ebc8.svg";